var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "row models-wrapper" },
    _vm._l(6, function (index) {
      return _c(
        "article",
        { key: index + "-skeleton-card", staticClass: "w-100" },
        [
          _c("ob1-cards", [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column h-100 justify-content-between",
              },
              [
                _c("div", { staticClass: "ob1-skeleton p-1" }, [
                  _c("div", {
                    staticClass: "ob1-skeleton-white mb-1",
                    staticStyle: { width: "140px", height: "30px" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", {
                      staticClass: "ob1-skeleton-white",
                      staticStyle: { width: "140px", height: "175px" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ms-1 mobile-infos",
                        staticStyle: { width: "140px" },
                      },
                      [
                        _c("div", {
                          staticClass: "ob1-skeleton-white",
                          staticStyle: { height: "45px" },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ob1-skeleton-white mt-1",
                          staticStyle: { height: "25px" },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ob1-skeleton-white mt-1",
                          staticStyle: { height: "45px" },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "ob1-skeleton-white mt-1",
                    staticStyle: { height: "40px" },
                  }),
                ]),
              ]
            ),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }